import React, { useState }  from "react";
import {
    FaTh,
    FaBars,
    FaRegChartBar,
    FaListAlt
}from "react-icons/fa";
import { NavLink } from 'react-router-dom';
import { HiClipboard } from "react-icons/hi";


const Sidebar = () => {
    const designation=localStorage.getItem('designation');

    const[isOpen ,setIsOpen] = useState(false);
    const toggle = () => setIsOpen (!isOpen);
    const menu={
        "Complainer":[
            {
                path:`/workorder/wof/stats`,
                name:"Statistics",
                icon:<FaRegChartBar/>
            },
            {
                path:`/workorder/wof/dashboard`,
                name:"Dashboard",
                icon:<FaListAlt/>
            },
            {
                path:"/workorder/wof/form-layouts/input-form",
                name:"New complaint",
                icon:<HiClipboard />
            }
        ],
        "Head of department":[
            {
                path:`/workorder/wof/stats`,
                name:"Statistics",
                icon:<FaRegChartBar/>
            },
            {
                path:`/workorder/wof/dashboard`,
                name:"Dashboard",
                icon:<FaListAlt/>,
            }
        ],
        "Director":[
            {
                path:`/workorder/wof/stats`,
                name:"Statistics",
                icon:<FaRegChartBar/>
            },
            {
                path:`/workorder/wof/dashboard`,
                name:"Dashboard",
                icon:<FaListAlt/>,
            }
        ],
        "Supervisor":[
            {
                path:`/workorder/wof/stats`,
                name:"Statistics",
                icon:<FaRegChartBar/>
            },
            {
                path:`/workorder/wof/dashboard`,
                name:"Dashboard",
                icon:<FaListAlt/>,
            }
        ],
        "AO Officer":[
            {
                path:`/workorder/wof/stats`,
                name:"Statistics",
                icon:<FaRegChartBar/>
            },
            {
                path:`/workorder/wof/dashboard`,
                name:"Dashboard",
                icon:<FaListAlt/>,
            }
        ],
        "Technician":[
            {
                path:`/workorder/wof/stats`,
                name:"Statistics",
                icon:<FaRegChartBar/>
            },
            {
                path:`/workorder/wof/dashboard`,
                name:"Dashboard",
                icon:<FaListAlt/>,
            },
        ],
        "Admin":[
            {
                path:`/workorder/wof/dashboard-Admin`,
                name:"Dashboard",
                icon:<FaTh/>,
            },
            {
                path:`/workorder/wof/dashboard-Ad`,
                name:"Edit Users Table",
                icon:<FaRegChartBar/>,
            },
        ],
    }

    return (
        <div className="container">
           <div style={{width: isOpen ? "170px" : "50px"}} className="sidebar">
               <div className="top_section">
                   <h1 style={{display: isOpen ? "block" : "none", Size: "10px"}} className="logo">NITTTR</h1>
                   <div style={{marginLeft: isOpen ? "50px" : "0px",transition:"all 0.5s"}} className="bars">
                       <FaBars onClick={toggle}/>
                   </div>
               </div>
               {    (designation) && (
                   menu[designation].map((item, index)=>(
                       <NavLink to={item.path} key={index} className="link" activeClassName="active">
                           <div className="icons">{item.icon}</div>
                           <div style={{display: isOpen ? "block" : "none"}} className="link_text">{item.name}</div>
                       </NavLink>
                   ))
                )
               }
           </div>
        </div>
    );
};

export default Sidebar;
